'use client';

import type { JSX, ReactNode } from 'react';

import { DropdownIcon } from '../../dropdown-icon';
import { Popover, PopoverContent, PopoverTrigger } from '../../popover';
import { usePopoverContext } from '../../popover/Popover';

import styles from './DropDown.module.scss';

export function DropDownItem({
  children,
  className,
  onClick,
  title,
}: {
  children: React.ReactNode;
  className: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  title?: string;
}) {
  const context = usePopoverContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick(event);
    context.setOpen(false);
  };

  return (
    <button
      className={className}
      onClick={handleClick}
      title={title}
      type="button"
    >
      {children}
    </button>
  );
}

function DropDown({
  disabled = false,
  buttonLabel,
  buttonAriaLabel,
  buttonTitle,
  buttonClassName,
  buttonIconClassName,
  children,
}: {
  disabled?: boolean;
  buttonAriaLabel?: string;
  buttonTitle?: string;
  buttonClassName: string;
  buttonIconClassName?: string;
  buttonLabel?: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <Popover placement="bottom-start" dismissOnAncestorScroll>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          aria-label={buttonAriaLabel || buttonLabel}
          title={buttonTitle || buttonLabel}
          className={buttonClassName}
        >
          {buttonIconClassName && <span className={buttonIconClassName} />}
          {buttonLabel && (
            <span className={styles['button-text']}>{buttonLabel}</span>
          )}
          <DropdownIcon
            size="sm"
            closed={false}
            className={styles['chevron-down']}
          />
        </button>
      </PopoverTrigger>
      <PopoverContent className={styles['dropdown']}>{children}</PopoverContent>
    </Popover>
  );
}

export { DropDown };
